export const getGenericInputStylesCP = (image, showIcon) => {
  return {
    input: {
      color: "#848484",
      border: "none",
      borderBottom: "1px solid #d6d6d6",
      width: "100%",
      fontSize: "14px",
      fontFamily: "AMX-Regular",
      backgroundImage: `url(${showIcon ? image : ""})`,
      backgroundPosition: "right 0px center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "20px",
      height: "30px",
      backgroundColor: "#fff",
    },
  };
};

export const getGenericInputStylesContainerTelcel = (image, showIcon, hasError) => {
  return {
    input: {
      '--placeholder-color': !hasError ? "#222222" : "#222222",
      '::placeholder': {
        color: 'var(--placeholder-color)'
      },
      color: !hasError ? "#222222" : "#222222",
      border: !hasError ? "1px solid #757575" : "1px solid #D32222",
      width: "calc(100% - 64px)",
      fontSize: "15px",
      fontFamily: "AMX-Regular",
      backgroundImage: `url(${showIcon ? image : ""})`,
      backgroundPosition: "right 16px bottom 7px",
      backgroundRepeat: "no-repeat",
      backgroundSize: "24px 24px",
      height: "22px",
      backgroundColor: "#fff",
      padding: "8px 48px 8px 16px",
      borderRadius: "40px",
    },
  };
};

export const applyFocusStyles = (element, hasError) => {
  element.style.border = hasError ? "1px solid #D32222" : "1px solid #0071D1";
};